import { FilterOption, LoanInventoryTableFields } from '../types';
export const applyFilters = (
  flatData: LoanInventoryTableFields[],
  selectedErrorCodes: Record<string, FilterOption[]>,
  selectedStatuses: any[],
  selectedPortfolios: any[]
) => {
  let flattenedSelectedErrorCodes = Object.values(selectedErrorCodes).flat();
  flattenedSelectedErrorCodes = flattenedSelectedErrorCodes.map((code) => {
    const renderedValue = code.value.split(':');
    const value =
      renderedValue[0] === '01' || renderedValue[0] === '04'
        ? `02:${renderedValue[1]}`
        : code.value;
    return {
      ...code,
      value,
      severity: code.severity === '01' || code.severity === '04' ? '02' : code.severity
    };
  });
  const errorSet = new Set(flattenedSelectedErrorCodes.map((error) => error.value));
  const errorSeveritySet = new Set(flattenedSelectedErrorCodes.map((error) => error.severity));
  const statusSet = new Set(selectedStatuses.map((selectedStatus) => selectedStatus.value));
  const portfolioSet = new Set(selectedPortfolios.map((portfolio) => portfolio.value));

  return flatData.filter((row) => {
    const rowErrorPairs =
      typeof row.errorMessageInfo === 'string'
        ? row.errorMessageInfo.split(',').map((code) => code.trim().split(':'))
        : [];

    const rowSeverities = rowErrorPairs.map(([sev]) => sev);
    const rowCombinedErrorKeys = rowErrorPairs.map(([sev, code]) => `${sev}:${code}`);

    const hasMatchingError =
      errorSet.size === 0 || rowCombinedErrorKeys.some((code) => errorSet.has(code));

    const hasMatchingSeverity =
      errorSeveritySet.size === 0 || rowSeverities.some((sev) => errorSeveritySet.has(sev));

    const hasMatchingStatus = statusSet.size === 0 || statusSet.has(row.loanStatus);
    const hasMatchingPortfolio =
      portfolioSet.size === 0 || portfolioSet.has(row.portfolioId.toString());

    return hasMatchingError && hasMatchingSeverity && hasMatchingStatus && hasMatchingPortfolio;
  });
};
